const UNKNOWN_REQUESTER = 'A team member';

const WARNING_LABELS: Readonly<Record<string, string>> = {
  general_kpis: 'General KPIs',
  general_views: 'Views',
  sentiment: 'Sentiment',
  sentiment_chart: 'Sentiment chart',
  audience: 'Audience',
  content: 'Content',
  content_sentiment: 'Content sentiment',
};

function warningKeys(warnings: unknown): string[] {
  return Array.isArray(warnings) ? warnings.filter((key): key is string => typeof key === 'string' && key !== '') : [];
}

/** "Audience, Sentiment unavailable" for the sections a finished workbook is missing; '' when none. */
export function exportWarningText(warnings: unknown): string {
  const labels = [...new Set(warningKeys(warnings).map((key) => WARNING_LABELS[key] ?? key))];
  return labels.length > 0 ? `${labels.join(', ')} unavailable` : '';
}

/** "Report ready" or "Report ready (Audience unavailable)". */
export function readyTitle(warnings: unknown): string {
  const text = exportWarningText(warnings);
  return text ? `Report ready (${text})` : 'Report ready';
}

export function requesterName(job: { requested_by?: { name?: string } | null }): string {
  return job.requested_by?.name?.trim() || UNKNOWN_REQUESTER;
}
